export default __webpack_public_path__ + "static/bfsupplypro-5748d2c4b21f2fb9d762182ac10fed23.png";